var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.931,
    height: 23.975,
    viewBox: "0 0 23.931 23.975",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_feather-phone",
    "data-name": "Icon feather-phone",
    d: "M25.1,19.451v3.308a2.205,2.205,0,0,1-2.4,2.205,21.821,21.821,0,0,1-9.516-3.385,21.5,21.5,0,0,1-6.616-6.616A21.821,21.821,0,0,1,3.177,5.4,2.205,2.205,0,0,1,5.371,3H8.679a2.205,2.205,0,0,1,2.205,1.9,14.157,14.157,0,0,0,.772,3.1,2.205,2.205,0,0,1-.5,2.327l-1.4,1.4a17.642,17.642,0,0,0,6.616,6.616l1.4-1.4a2.205,2.205,0,0,1,2.327-.5,14.158,14.158,0,0,0,3.1.772A2.205,2.205,0,0,1,25.1,19.451Z",
    transform: "translate(-2.167 -2)",
    fill: "none",
    stroke: "#bcbbbb",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.dc69edad195d6d30e0e7bb80e1f0b5e3.svg";
export { ForwardRef as ReactComponent };